<template>
  <div
    class="d-flex-column justify-start align-start mobile_summary_container gap-0 hide_scroll"
    :class="[isOpen ? 'opened' : 'closed']"
  >
    <div class="d-flex-row space-between flex-1">
      <h4 class="font-family-1 title-h5 t-white">
        {{ $t("cart.summary") }}
      </h4>
      <button class="mobile_summary_btn" @click.stop="setOpen">
        <ChevRight class="chevron-icon" />
      </button>
    </div>

    <LazyCalculatorsFc25FcCoachingBoostCart
      v-if="currentGamePackSlug === 'fc-coaching-boost'"
    />
    <LazyCalculatorsFc25FcSquadBoostCart
      v-else-if="currentGamePackSlug === 'fc-squad-battles-boost'"
    />
    <LazyCalculatorsFc25Fc25ObjectiveBoostCart
      v-else-if="currentGamePackSlug === 'fc-objectives-boost'"
    />
    <LazyCalculatorsFc25Fc25CampaignFinalsBoostCart
      v-else-if="currentGamePackSlug === 'fc-fut-champions-final-boost'"
    />
    <LazyCalculatorsFc25Fc25CampaignPlayOffCart
      v-else-if="currentGamePackSlug === 'fc-fut-champions-playoffs-boost'"
    />
    <LazyCalculatorsFc25Fc25DivisionRivalsCart
      v-else-if="currentGamePackSlug === 'fc-division-rivals-boost'"
    />
    <LazyCalculatorsFc25Fc25DivisionRivalsWins
      v-else-if="currentGamePackSlug === 'fc-division-rivals-wins-boost'"
    />
    <LazyCalculatorsFc25FcBundesligsBoostCart
      v-else-if="currentGamePackSlug === 'fc-tots-cup-boost'"
    />
    <hr class="horizontal md-hide" style="margin: 8px 0" />
  </div>
</template>

<script setup>
import ChevRight from "~/components/icons/ChevRight.vue";
const { currentGamePackSlug } = useGameComposable();
const isOpen = ref(false);

const setOpen = () => {
  isOpen.value = !isOpen.value;
  toggleBodyScroll(isOpen.value);
};

onBeforeUnmount(() => {
  isOpen.value = false;
  toggleBodyScroll(false);
});
</script>
<style lang="scss">
.mobile_summary_container {
  position: relative;
  overflow: hidden;
  margin-bottom: 18px;
  border-bottom: 1px solid var(--stroke-medium);
  padding-bottom: 0;
  transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &.closed {
    max-height: 58px;
  }

  &.opened {
    max-height: 65vh;
    overflow-y: auto;
    padding-bottom: 18px;
  }

  .mobile_summary_btn {
    background: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    .chevron-icon {
      width: 25px;
      height: 25px;
      transform: rotate(90deg);
      transition: transform 0.3s ease;
    }
  }

  &.opened .mobile_summary_btn .chevron-icon {
    transform: rotate(-90deg);
  }
}
</style>
